import { Skeleton } from '@shared/components/ui/shadcn';

export const ProductFormSkeleton = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-6 gap-8">
      <div className="lg:col-span-2">
        <div className="sticky top-6 space-y-2">
          <Skeleton className="h-6 w-36 rounded-full bg-hover-press" />
          <Skeleton className="h-4 w-52 rounded-full bg-hover-press" />
        </div>
      </div>
      <div className="lg:col-span-4">
        <div className="space-y-4">
          <div className="flex justify-end">
            <Skeleton className="h-10 w-40 rounded-md bg-hover-press" />
          </div>
          <div className="border-2 border-dashed border-card-border rounded-lg p-8 space-y-4">
            <Skeleton className="h-10 w-10 mx-auto rounded-full bg-hover-press" />
            <Skeleton className="h-5 w-48 rounded-full mx-auto bg-hover-press" />
            <Skeleton className="h-4 w-72 rounded-full mx-auto bg-hover-press" />
          </div>
          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <Skeleton className="h-4 w-48 rounded-full bg-hover-press" />
              <Skeleton className="h-10 w-40 rounded-md bg-hover-press" />
            </div>
            <div className="space-y-3">
              {[1, 2].map((key) => (
                <div
                  key={key}
                  className="flex items-center justify-between gap-4 py-3 border-b border-card-border last:border-b-0"
                >
                  <div className="flex-grow min-w-0 flex items-center gap-3">
                    <Skeleton className="w-12 h-12 rounded-md bg-hover-press" />
                    <div className="space-y-2 flex-1">
                      <Skeleton className="h-4 w-40 rounded-full bg-hover-press" />
                      <Skeleton className="h-3 w-24 rounded-full bg-hover-press" />
                    </div>
                  </div>
                  <div className="flex items-center gap-3 flex-shrink-0">
                    <Skeleton className="h-10 w-28 rounded-md bg-hover-press" />
                    <Skeleton className="h-8 w-8 rounded-full bg-hover-press" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

